import { I18n } from "@assets/strings";
import React, { useState } from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { useSuggestedCourses } from "@domain/lms/course/hooks";
import { ArrowNavigator } from "@ui/components/arrowNavigator";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { Tertiary } from "@ui/components/containers/textBlocks";
import { CourseThumbnailSmall } from "@ui/components/course/courseThumbnailSmall";
import { Row } from "@ui/components/layout";
import { gap } from "@ui/styles/utils";

type CourseSuggestCardProps = React.HTMLAttributes<HTMLDivElement>;

export const CourseSuggestCard: React.FC<CourseSuggestCardProps> = ({ ...htmlProps }) => {
	const { result: courses, loading } = useSuggestedCourses(10);
	const [currentIndex, setIndex] = useState(0);

	return (
		<Container {...htmlProps}>
			<Row gap={10} align="center" justify="space-between">
				<PrimaryMedium>{I18n.t("course.suggest.title")}</PrimaryMedium>
				<StyledArrowNavigator
					small
					previous={() => setIndex((i) => (i - 1 + courses.length) % courses.length)}
					next={() => setIndex((i) => (i + 1) % courses.length)}
				/>
			</Row>
			{loading ? (
				<ClipLoader />
			) : courses && courses.length > 0 ? (
				<CourseThumbnailSmall key={courses[currentIndex].id} course={courses[currentIndex]} />
			) : (
				<Tertiary>{I18n.t("course.suggest.no_results")}</Tertiary>
			)}
		</Container>
	);
};

const Container = styled.div`
	${gap(16)};
`;

const StyledArrowNavigator = styled(ArrowNavigator)`
	width: 70px;
`;
